/**
 * RTL (Right-to-Left) Language Utilities
 *
 * Centralized utilities for detecting RTL languages.
 * Use these instead of hardcoding language checks like `language === 'ar'`
 */

/**
 * List of RTL language codes
 * Includes: Arabic, Urdu, Hebrew, Persian/Farsi, Pashto, Sindhi, Kurdish (Sorani)
 */
export const RTL_LANGUAGES = ['ar', 'ur', 'he', 'fa', 'ps', 'sd', 'ckb'] as const

export type RTLLanguage = typeof RTL_LANGUAGES[number]

/**
 * Check if a language code is RTL
 * @param language - Language code (e.g., 'ar', 'en', 'ur')
 * @returns true if the language is RTL
 */
export function isRTLLanguage(language: string | undefined | null): boolean {
  if (!language) return false
  // Handle locale codes like 'ar-SA' by extracting the base language
  const baseLanguage = language.split('-')[0].toLowerCase()
  return RTL_LANGUAGES.includes(baseLanguage as RTLLanguage)
}
